import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./context/LangContext";
import { ThemeProvider } from "./context/ThemeContext";
import { MemberProvider } from "./context/MemberContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/PublicLayout";
import Home from "./pages/Home";
import NewsDetail from "./pages/NewsDetail";

// Lazy load less-used pages
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Masthead = lazy(() => import("./pages/Masthead"));
const Login = lazy(() => import("./pages/Login"));
const Admin = lazy(() => import("./pages/Admin"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const AIChat = lazy(() => import("./pages/AIChat"));
const MemberAuth = lazy(() => import("./pages/MemberAuth"));
const Profile = lazy(() => import("./pages/Profile"));
const Premium = lazy(() => import("./pages/Premium"));
const PremiumSuccess = lazy(() => import("./pages/PremiumSuccess"));
const EntityPage = lazy(() => import("./pages/EntityPage"));
const LeaderboardPage = lazy(() => import("./pages/LeaderboardPage"));

const ADMIN_SECRET_PATH = "loft-yonetim-2026";

const PageLoader = () => (
  <div className="min-h-screen bg-[#0a0a0b] flex items-center justify-center">
    <div className="animate-pulse text-amber-500 text-sm">Yükleniyor...</div>
  </div>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
        <ThemeProvider>
        <MemberProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/haber/:slug" element={<PublicLayout><NewsDetail /></PublicLayout>} />
              <Route path="/news/:id" element={<PublicLayout><NewsDetail /></PublicLayout>} />
              
              {/* Static Pages */}
              <Route path="/hakkimizda" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/iletisim" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/kunye" element={<PublicLayout><Masthead /></PublicLayout>} />
              <Route path="/abonelik-iptal" element={<PublicLayout><Unsubscribe /></PublicLayout>} />
              <Route path="/ai-asistan" element={<PublicLayout><AIChat /></PublicLayout>} />
              <Route path="/uye" element={<PublicLayout><MemberAuth /></PublicLayout>} />
              <Route path="/profil" element={<PublicLayout><Profile /></PublicLayout>} />
              <Route path="/premium" element={<PublicLayout><Premium /></PublicLayout>} />
              <Route path="/premium/basarili" element={<PublicLayout><PremiumSuccess /></PublicLayout>} />
              <Route path="/entity/:entityType/:entityName" element={<PublicLayout><EntityPage /></PublicLayout>} />
              <Route path="/liderlik" element={<PublicLayout><LeaderboardPage /></PublicLayout>} />
              
              {/* Secret Admin Login - Hidden URL */}
              <Route path={`/${ADMIN_SECRET_PATH}`} element={<Login />} />
              <Route path={`/${ADMIN_SECRET_PATH}/panel`} element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
              
              {/* Legacy routes redirect to home */}
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/admin" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        </MemberProvider>
        </ThemeProvider>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
